import React from 'react';
import { Card, Col, Row, Container, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import {
  FaDatabase,
  FaIdCard,
  FaBullseye,
  FaBullhorn,
  FaGift,
  FaShoppingCart,
  FaUserShield,
  FaShareAlt,
  FaArchive,
  FaUserCheck,
  FaUserMinus,
  FaHome,
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaClipboardList
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../assets/mboxLogo.jpeg'; 
const PoliticasDePrivacidad = () => {
  const policySections = [
    {
      icon: <FaDatabase className="text-primary me-2 fs-5" />,
      title: "Información que Recopilamos",
      content: (
        <>
          <p className="mb-2">Podemos recopilar la siguiente información personal:</p>
          <ul className="mb-0 ps-3">
            <li>Nombre completo.</li>
            <li>Número de teléfono.</li>
            <li>Dirección de correo electrónico.</li>
            <li>Dirección general de residencia o entrega.</li>
            <li>Número de identidad, RTN o documentación similar cuando sea necesario.</li>
            <li>Número de casillero asignado.</li>
            <li>Historial de envíos y paquetes recibidos.</li>
            <li>Información relacionada con pagos y facturación.</li>
            <li>Información proporcionada voluntariamente durante promociones, sorteos, encuestas o actividades organizadas por MBOX.</li>
          </ul>
        </>
      )
    },
    {
      icon: <FaIdCard className="text-success me-2 fs-5" />,
      title: "Verificación de Identidad",
      content: (
        <>
          <p className="mb-2">En determinadas circunstancias, especialmente cuando existan razones de seguridad, prevención de fraude o requisitos operativos, podremos solicitar información adicional para verificar la identidad del cliente. Esta información podrá incluir:</p>
          <ul className="mb-2 ps-3">
            <li>Fotografía del documento de identidad.</li>
            <li>Pasaporte.</li>
            <li>Licencia de conducir.</li>
            <li>Fotografía del titular.</li>
            <li>Copias físicas o electrónicas de documentos de identificación.</li>
          </ul>
          <p className="mb-0 text-muted fst-italic">Esta información será utilizada únicamente para procesos de validación y seguridad.</p>
        </>
      )
    },
    {
      icon: <FaBullseye className="text-info me-2 fs-5" />,
      title: "Finalidad del Uso de la Información",
      content: (
        <>
          <p className="mb-2">La información recopilada podrá utilizarse para:</p>
          <ul className="mb-0 ps-3">
            <li>Crear y administrar casilleros.</li>
            <li>Identificar correctamente al titular de una cuenta.</li>
            <li>Recibir, clasificar y entregar paquetes.</li>
            <li>Notificar la llegada de paquetes o documentos.</li>
            <li>Procesar pagos y facturación.</li>
            <li>Brindar soporte y atención al cliente.</li>
            <li>Verificar identidad cuando sea necesario.</li>
            <li>Prevenir fraudes, actividades ilícitas o accesos no autorizados.</li>
            <li>Cumplir obligaciones legales y regulatorias.</li>
            <li>Informar sobre promociones, servicios, actualizaciones y actividades relacionadas con MBOX.</li>
          </ul>
        </>
      )
    },
    {
      icon: <FaBullhorn className="text-warning me-2 fs-5" />,
      title: "Información Utilizada para Marketing",
      content: (
        <>
          <p className="mb-2">Podremos utilizar información de contacto como correo electrónico, número telefónico o redes sociales para comunicar:</p>
          <ul className="mb-2 ps-3">
            <li>Promociones especiales.</li>
            <li>Descuentos.</li>
            <li>Sorteos y giveaways.</li>
            <li>Nuevos servicios.</li>
            <li>Información relevante sobre nuestros productos y operaciones.</li>
          </ul>
          <p className="mb-0 text-muted fst-italic">El cliente podrá solicitar dejar de recibir comunicaciones promocionales en cualquier momento.</p>
        </>
      )
    },
    {
      icon: <FaGift className="text-danger me-2 fs-5" />,
      title: "Participación en Actividades Promocionales",
      content: (
        <>
          <p className="mb-2">Cuando un cliente participe voluntariamente en sorteos, promociones, giveaways, encuestas o dinámicas organizadas por MBOX, podrá proporcionar información adicional requerida para dicha actividad.</p>
          <p className="mb-0">La participación en estas actividades es completamente opcional y no afecta el acceso a los servicios principales de la empresa.</p>
        </>
      )
    },
    {
      icon: <FaShoppingCart className="text-primary me-2 fs-5" />,
      title: "Compras Asistidas",
      content: (
        <p className="mb-0">
          Cuando el cliente solicite una compra asistida y proporcione información de pago para realizar una transacción específica, dicha información será utilizada únicamente para completar la compra autorizada. MBOX no almacena de forma permanente datos de tarjetas bancarias ni credenciales financieras una vez finalizado el proceso.
        </p>
      )
    },
    {
      icon: <FaUserShield className="text-secondary me-2 fs-5" />,
      title: "Protección de la Información",
      content: (
        <>
          <p className="mb-2">MBOX implementa medidas administrativas, operativas y tecnológicas razonables para proteger la información contra:</p>
          <ul className="mb-2 ps-3">
            <li>Acceso no autorizado.</li>
            <li>Alteración de datos.</li>
            <li>Divulgación indebida.</li>
            <li>Uso fraudulento.</li>
            <li>Pérdida accidental de información.</li>
          </ul>
          <p className="mb-0">El acceso a los datos personales está restringido únicamente al personal autorizado que lo requiera para el desempeño de sus funciones.</p>
        </>
      )
    },
    {
      icon: <FaShareAlt className="text-success me-2 fs-5" />,
      title: "Compartición de Información",
      content: (
        <>
          <p className="mb-2">MBOX no vende, alquila ni comercializa información personal de sus clientes. La información únicamente podrá compartirse cuando sea necesario con:</p>
          <ul className="mb-0 ps-3">
            <li>Empresas de transporte y logística.</li>
            <li>Agentes aduaneros.</li>
            <li>Autoridades competentes.</li>
            <li>Instituciones que legalmente lo requieran.</li>
          </ul>
        </>
      )
    },
    {
      icon: <FaArchive className="text-info me-2 fs-5" />,
      title: "Conservación de la Información",
      content: (
        <>
          <p className="mb-2">La información personal será almacenada durante el tiempo que sea necesario para:</p>
          <ul className="mb-0 ps-3">
            <li>Mantener activa la cuenta del cliente.</li>
            <li>Cumplir obligaciones legales.</li>
            <li>Atender reclamos o consultas.</li>
            <li>Mantener registros operativos y administrativos.</li>
          </ul>
        </>
      )
    },
    {
      icon: <FaUserCheck className="text-warning me-2 fs-5" />,
      title: "Derechos del Cliente",
      content: (
        <>
          <p className="mb-2">El cliente podrá solicitar:</p>
          <ul className="mb-0 ps-3">
            <li>Actualización de sus datos.</li>
            <li>Corrección de información incorrecta.</li>
            <li>Verificación de los datos almacenados.</li>
            <li>Eliminación de información cuando legalmente proceda.</li>
          </ul>
        </>
      )
    },
    {
      icon: <FaUserMinus className="text-danger me-2 fs-5" />,
      title: "Menores de Edad",
      content: (
        <>
          <p className="mb-2">Los servicios de MBOX están dirigidos exclusivamente a personas mayores de 18 años.</p>
          <p className="mb-0">No recopilamos intencionalmente información de menores de edad. Si detectamos que se ha proporcionado información personal de un menor sin la autorización correspondiente de sus representantes legales, procederemos a eliminar dicha información de nuestros registros en el menor tiempo posible.</p>
        </>
      )
    },
    {
  icon: <FaClipboardList className="text-danger me-2 fs-5" />,
  title: "Procesos Aduaneros y Retenciones",
  content: (
    <ul className="mb-0 ps-3 text-secondary">
      <li className="mb-2">Las autoridades aduaneras pueden realizar inspecciones, revisiones o retenciones de cargas cuando lo consideren necesario. Estos procesos son externos a MBOX y pueden generar modificaciones en los tiempos estimados de entrega.</li>
      <li className="mb-2">MBOX no tiene control sobre los procedimientos, tiempos de respuesta o decisiones tomadas por las autoridades competentes; sin embargo, damos seguimiento constante y realizamos las gestiones necesarias para la liberación de las cargas.</li>
      <li className="mb-2">Los paquetes retenidos por procesos aduaneros no se consideran extraviados ni perdidos, por lo que no aplican reembolsos mientras la carga se encuentre identificada y en proceso de liberación.</li>
      <li className="mb-0">MBOX será responsable únicamente en casos donde exista pérdida o extravío atribuible directamente a nuestra operación.</li>
    </ul>
  )
}
  ];

  const contactInfo = [
    {
      icon: <FaWhatsapp className="me-3 text-success fs-4" />,
      text: "WhatsApp: 9874-4314",
      link: "https://wa.me/50498744314"
    },
    {
      icon: <FaEnvelope className="me-3 text-primary fs-4" />,
      text: "servicioalclientembox@gmail.com",
      link: "mailto:servicioalclientembox@gmail.com"
    },
    {
      icon: <FaInstagram className="me-3 fs-4" style={{ color: '#E1306C' }} />,
      text: "@mbox.express",
      link: "https://instagram.com/mbox.express"
    }
  ];

  return (
    <section 
      className="py-5" 
      style={{ 
        background: "linear-gradient(135deg, #182848 0%, #4b6cb7 100%)", 
        minHeight: "100vh" 
      }}
    >
      <Container className="px-3" style={{ maxWidth: '1100px' }}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {/* Cabecera / Navegación */}
          <Row className="mb-5 align-items-center justify-content-between">
            <Col xs="auto">
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                <Link to="/" className="text-decoration-none">
                  <div className="d-flex align-items-center">
                    <img
                      src={logo}
                      alt="MBox Logo"
                      className="img-fluid me-3 shadow-sm"
                      style={{ height: '45px', borderRadius: '8px' }}
                    />
                    <span className="text-white fw-bold fs-5 d-none d-sm-inline">MBox Honduras</span>
                  </div>
                </Link>
              </motion.div>
            </Col>
            <Col xs="auto">
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                <Link to="/" className="text-decoration-none">
                  <Button variant="outline-light" className="d-flex align-items-center px-3 shadow-sm">
                    <FaHome className="me-2" />
                    <span>Inicio</span>
                  </Button>
                </Link>
              </motion.div>
            </Col>
          </Row>

         
          <div className="text-center mb-5">
            <h1 className="fw-bold text-white mb-3">Política de Privacidad</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '800px', fontSize: '1.1rem', lineHeight: '1.6' }}>
              En <strong>MBOX S. de R.L.</strong> valoramos la confianza de nuestros clientes y nos comprometemos a proteger la privacidad y seguridad de la información personal que nos proporcionan. Esta Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos la información obtenida a través de nuestros servicios de casillero internacional, logística, transporte de paquetes, compras asistidas y demás servicios relacionados.
            </p>
          </div>

         
          <Row className="g-4">
            {policySections.map((section, index) => (
              <Col lg={6} md={12} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.05, duration: 0.4 }}
                  className="h-100"
                >
                  <Card className="h-100 border-0 shadow bg-white rounded-3">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        {section.icon}
                        <h5 className="fw-bold text-dark mb-0 ms-2">{section.title}</h5>
                      </div>
                      <div className="text-secondary lh-lg" style={{ fontSize: '0.95rem' }}>
                        {section.content}
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
            className="mt-5"
          >
            <Card className="border-0 shadow-lg rounded-3 bg-white">
              <Card.Body className="p-4 p-md-5">
                <div className="mb-4 pb-2 border-bottom">
                  <h4 className="fw-bold text-dark mb-2">Contacto</h4>
                  <p className="text-secondary mb-0">
                    Si tiene consultas relacionadas con esta Política de Privacidad o sobre el tratamiento de su información personal, puede comunicarse a través de nuestros canales oficiales:
                  </p>
                </div>
                
                <Row className="g-4">
                  {contactInfo.map((contact, i) => (
                    <Col md={4} key={i}>
                      <div className="d-flex align-items-center text-dark p-3 rounded bg-light border h-100">
                        <div>{contact.icon}</div>
                        <div>
                          {contact.link ? (
                            <a
                              href={contact.link}
                              className="text-dark text-decoration-none fw-medium"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {contact.text}
                            </a>
                          ) : (
                            <span className="text-dark fw-medium">{contact.text}</span>
                          )}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="text-center mt-5 mb-4 pb-3"
          >
            <p className="text-white-50 fst-italic small mx-auto" style={{ maxWidth: '600px' }}>
              Al utilizar nuestros servicios, el cliente acepta las prácticas descritas en esta Política de Privacidad. MBOX S. de R.L.
            </p>
          </motion.div>

        </motion.div>
      </Container>
    </section>
  );
};

export default PoliticasDePrivacidad;